import { Mail, CircleAlert } from 'lucide-react';

export const EmailNotice = ({ status }) => {
  if (!status) return null;
  const accepted = status.client === 'accepted';
  const pending = ['pending', 'sending'].includes(status.client);
  const text = accepted
    ? 'Votre e-mail de confirmation est en cours d’acheminement. Pensez à vérifier vos courriers indésirables.'
    : pending
      ? 'Votre demande est enregistrée. L’envoi de votre e-mail de confirmation est en cours.'
      : 'Votre demande est enregistrée, mais l’envoi de l’e-mail de confirmation n’a pas pu être confirmé. Vous pouvez contacter directement le cabinet avec votre référence.';
  return <div className={`email-notice ${accepted || pending ? '' : 'email-notice-warning'}`} role={accepted || pending ? 'status' : 'alert'} data-testid="quote-email-notice">
    {accepted || pending ? <Mail size={18} aria-hidden="true" /> : <CircleAlert size={18} aria-hidden="true" />}<p data-testid="quote-email-status-text">{text}</p>
  </div>;
};